/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-04-21T17:44:56.325
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listReportWorkflowItemCount,
	listReportWorkflowItemCountInit,
	listReportWorkflowItemCountByAuthorizations,
	deleteReportWorkflowItemCount
} from '@api/report/ReportWorkflowItemCount';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listReportWorkflowItemCount({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportWorkflowItemCount(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportWorkflowItemCountByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportWorkflowItemCountByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportWorkflowItemCountInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportWorkflowItemCountInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteReportWorkflowItemCount({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportWorkflowItemCount({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
